/**
 * Created by PanJiaChen on 16/11/18.
 */
import router from '../router'
import encryptlong from 'encryptlong'

export function encryptRSA (word) {
  console.log('encryptRSA')
  var PUBLIC_KEY = '-----BEGIN PUBLIC KEY-----\n' +
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCM/kBTkxNXg\n' +
    'lPURXg6fvM/ISVlwXeGdKWQGSkA2ol5ljEHC41oxg2LJ0Mr7t\n' +
    'TLe0CJFA01U3FnGxt3fFDOprHsyvPslOWHDcTWW0rUqVxeUya\n' +
    'mfVPJbsV3KZCDa9Y0TIJYIKFWL6f4FmuYjRAxwDhoAIPRbFQS\n' +
    'NuC00dbKj798twIDAQAB\n' +
    '-----END PUBLIC KEY-----'

  //  处理过长的问题
  let encrypt = new encryptlong()
  encrypt.setPublicKey(PUBLIC_KEY)
  let encrypted = encrypt.encryptLong(word)
  return encrypted
}

export function encodeParam (string) {
  return encodeURIComponent(string)
}

export function decodeParam (code) {
  return decodeURIComponent(code)
}

export function getUserMenus () {
  const menus = JSON.parse(decodeParam(localStorage.getItem('user-menus')))
  return menus
}

export function getUserRoutes () {
  return JSON.parse(decodeParam(localStorage.getItem('user-userRoutes')))
}

export function getUserDashboardBtn () {
  return localStorage.getItem('user-dashboardBtn') ? JSON.parse(decodeParam(localStorage.getItem('user-dashboardBtn'))) : null
}

export function getTemplateBtn () {
  return localStorage.getItem('user-templateBtn') ? JSON.parse(decodeParam(localStorage.getItem('user-templateBtn'))) : null
}

export function setStore (name, content, time) {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  time = time || 60
  let cacheExpireDate = (new Date() - 1) + time * 1000
  content = {val: content, exp: cacheExpireDate}
  window.localStorage.setItem(name, JSON.stringify(content))
}

/**
 * 获取localStorage
 */
export function getStore (name) {
  if (!name) return
  let content = window.localStorage.getItem(name) || ''
  if (content == 'undefined' || content == '') {
    return ''
  }
  let cacheObj = JSON.parse(content)
  if (cacheObj.exp < new Date() - 1) {
    removeStore(name)
    content = ''
  } else {
    content = cacheObj.val
  }
  return content
}

/**
 * 删除localStorage
 */
export function removeStore (name) {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime (time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime (time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject (url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength (str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param (json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj (url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text (val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge (target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass (element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime (type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce (func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone (source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function isJSON (str) {
  if (typeof str === 'string') {
    try {
      JSON.parse(str)
      return true
    } catch (e) {
      return false
    }
  }
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr (arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString () {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass (ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass (ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass (ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

export function clearLocalStorage(){
  const old=deepClone(localStorage)
  localStorage.clear();
  const needRember=['ruleWeb_ThemeID']
  for(let i=0;i<needRember.length;i++){
      if(old[needRember[i]]) window.localStorage.setItem(needRember[i],old[needRember[i]])
  }

}

export function openModule(moduleInfo){
  const {type, name, id} = moduleInfo
  var url = ''
  if (type == 1) {
    // 规则集
    url = `/risk/rulesCan?componentId=${id}&componentName=${name}`
  } else if (type == 2) {
    // 决策表
    url = `/risk/decisionTables?componentId=${id}&componentName=${name}`
  } else if (type == 3) {
    // 评分卡
    url = `/risk/score?componentId=${id}&componentName=${name}`
  } else if (type == 4) {
    url = `/risk/decisionTree?componentId=${id}&componentName=${name}`
  }
  // if(url.length>0) this.$router.push(url)
  const locationData = window.location
  const themeID=localStorage.getItem('ruleWeb_ThemeID')
  if (url.length > 0) window.open(`${locationData.origin}${locationData.pathname}?ThemeID${themeID}ThemeID#${url}`)
}

// 获取工作空间信息
export function getSpaceInfo () {
  var res = localStorage.getItem('space-info')
  if (res) {
    res = JSON.parse(res)
  } else {
    if (getRouterInfo().meta.specialSpaceId) {
      res = {
        id: 0,
      }
    } else {
      // 回到空间页
      router.replace({name: 'Dashboard'})
    }
  }
  return res
}

function getRouterInfo() {
  return router.currentRoute
}

export function systemInfoByIP () {
  const location = window.location
  const route = location.origin + location.pathname

  const bankList = {
    'http://192.168.9.49:9999': 'DO26',
    'http://192.168.9.100:20000': 'DO26',
    'http://106.0.52.159:8081': 'NHNS',
    'http://192.168.9.100:20004': 'NHNS',
    'http://51.128.6.9:8001': 'BBG',
    'http://51.0.64.14:8009': 'BBG',
    'http://51.0.64.15:8009': 'BBG',
    'http://51.0.64.17:8009': 'BBG',
    'http://51.32.64.14:8009': 'BBG',
    'http://51.32.64.15:8009': 'BBG',
    'http://51.32.64.17:8009': 'BBG',
    'http://192.168.9.100:20001': 'BBG',
    'http://61.144.45.10:10010': 'SR',
    'http://192.168.9.100:6772': 'JD',
    'http://192.168.9.100:20003': 'JD',
    'http://192.16.72.116:6680': 'HK',
    'http://192.16.75.116:6680': 'HK',
    'http://200.0.7.14:6680': 'HK',
    'http://200.0.7.15:6680': 'HK',
    'http://200.0.7.21:6680': 'HK',
    'http://192.168.9.100:20005': 'HK',
    'http://10.150.5.159:6680': 'ZJK',
    'http://10.145.250.44:8000': 'ZJK',
    'http://192.168.9.100:20002': 'ZJK'
  }

  const bankInfo = {
    DO26: {
      'systemName': '睿鹰策略中台',
      'copyright': 'Copyright © 2020-2021 二十六度数字科技(广州)有限公司 All Rights Reserved.',
      'themeID': '',

      'other': 'http://192.168.9.100:20000'
    },
    ZJK: {
      'systemName': '睿鹰策略中台',
      'copyright': 'Copyright © 2020-2021 二十六度数字科技(广州)有限公司 All Rights Reserved.',
      'themeID': 'red',

      'other': 'http://192.168.9.100:20002',
      'sit': 'http://192.168.9.100:20002',
      'uat': 'http://10.150.5.159:6680',
      'prod': 'http://10.145.250.44:8000',

      'http://192.168.9.100:20003/riskManagement': 'sit',
      'http://192.168.9.100:20003/riskManagement/': 'sit',
      'http://10.150.5.159:6680/riskManagement': 'uat',
      'http://10.150.5.159:6680/riskManagement/': 'uat',
      'http://10.145.250.44:8000/riskManagement': 'prod',
      'http://10.145.250.44:8000/riskManagement/': 'prod'
    },
    HK: {
      'systemName': '策略引擎',
      'copyright': 'Copyright © 2020-2021 二十六度数字科技(广州)有限公司 All Rights Reserved.',
      'themeID': 'red',

      'other': 'http://192.168.9.100:20005',
      'sit': 'http://192.16.72.116:6680',
      'uat': 'http://192.16.75.116:6680',
      'prod1': 'http://200.0.7.14:6680',
      'prod2': 'http://200.0.7.15:6680',
      'prod3': 'http://200.0.7.21:6680',

      'http://192.16.72.116:6680/riskManagement': 'sit',
      'http://192.16.72.116:6680/riskManagement/': 'sit',
      'http://192.16.75.116:6680/riskManagement': 'uat',
      'http://192.16.75.116:6680/riskManagement/': 'uat',
      'http://200.0.7.14:6680/riskManagement': 'prod1',
      'http://200.0.7.14:6680/riskManagement/': 'prod1',
      'http://200.0.7.15:6680/riskManagement': 'prod2',
      'http://200.0.7.15:6680/riskManagement/': 'prod2',
      'http://200.0.7.21:6680/riskManagement': 'prod3',
      'http://200.0.7.21:6680/riskManagement/': 'prod3'
    },
    JD: {
      'systemName': '菁卡云-策略引擎',
      'copyright': 'Copyright © 2020-2021 二十六度数字科技(广州)有限公司 All Rights Reserved.',
      'themeID': 'red',

      'other': 'http://192.168.9.100:20003'// 没有匹配到环境时默认apiIP
    },
    NHNS: {
      'systemName': '睿鹰策略中台',
      'copyright': 'Copyright © 2020-2021 二十六度数字科技(广州)有限公司 All Rights Reserved.',
      'themeID': 'red',

      'other': 'http://192.168.9.100:20004',
      'uat': 'http://106.0.52.159:8081',
      'pro': 'http://106.0.42.120:8081',

      'http://106.0.52.159:8081/riskManagement': 'uat',
      'http://106.0.52.159:8081/riskManagement/': 'uat',
      'http://106.0.42.120:8081/riskManagement': 'pro',
      'http://106.0.42.120:8081/riskManagement/': 'pro'
    },
    BBG: {
      'systemName': '睿鹰策略中台',
      'copyright': 'Copyright © 2020-2021 二十六度数字科技(广州)有限公司 All Rights Reserved.',
      'themeID': 'red',

      'other': 'http://192.168.9.100:20001/ruleApi',
      'uat': 'http://51.128.6.9:8001',
      // 生产地址 -双中心4台nginx和两台VIP
      'prod1': 'http://51.0.64.17:8009/ruleApi',
      'prod2': 'http://51.0.64.17:8009/ruleApi',
      'prod3': 'http://51.0.64.17:8009/ruleApi',
      'prod4': 'http://51.32.64.17:8009/ruleApi',
      'prod5': 'http://51.32.64.17:8009/ruleApi',
      'prod6': 'http://51.32.64.17:8009/ruleApi',

      'http://51.128.6.9:8001/riskManagement': 'uat',
      'http://51.128.6.9:8001/riskManagement/': 'uat',
      'http://51.0.64.14:8009/riskManagement': 'prod1',
      'http://51.0.64.14:8009/riskManagement/': 'prod1',
      'http://51.0.64.15:8009/riskManagement': 'prod2',
      'http://51.0.64.15:8009/riskManagement/': 'prod2',
      'http://51.0.64.17:8009/riskManagement': 'prod3',
      'http://51.0.64.17:8009/riskManagement/': 'prod3',
      'http://51.32.64.14:8009/riskManagement': 'prod4',
      'http://51.32.64.14:8009/riskManagement/': 'prod4',
      'http://51.32.64.15:8009/riskManagement': 'prod5',
      'http://51.32.64.15:8009/riskManagement/': 'prod5',
      'http://51.32.64.17:8009/riskManagement': 'prod6',
      'http://51.32.64.17:8009/riskManagement/': 'prod6'
    },
    SR: {
      'systemName': '睿鹰策略中台',
      'copyright': '版权所有： 上海通联金融服务有限公司',
      'themeID': 'green',

      'other': 'http://51.0.64.17:8009/ruleApi',
      'sit': 'http://61.144.45.10:10010',

      'http://61.144.45.10:10010/riskManagement': 'sit',
      'http://61.144.45.10:10010/riskManagement/': 'sit'
    }
  }
  var bankName = ''
  if (bankList[location.origin]) {
    if (bankList[location.origin] == 'DO26' || bankList[location.origin] == 'JD') {
      if (location.pathname == '/JD_riskManagement/') {
        bankName = 'JD'
      } else {
        bankName = 'DO26'
      }
    } else {
      bankName = bankList[location.origin]
    }
  } else {
    bankName = 'DO26'
  }
  // bankName='HK'//临时测试
  const bankItem = bankInfo[bankName]

  var info = {}
  info.bank = bankName
  info.env = bankItem[route] || 'other'
  info.envAPI = bankItem[info.env]
  info.bankImg = route + `static/image/${bankName}`
  info.systemName = bankItem.systemName
  info.copyright = bankItem.copyright
  info.themeID =  bankItem.themeID?bankItem.themeID:'blue'
  info.themeImg = route + 'static/image/theme/'

  return info
}

// 计算table最大高度
export function setTableMaxH (vueObj,pageTopEl) {
    var paginationH=20+32
  if(pageTopEl.indexOf('noPageNum')!=-1) paginationH=0
  const setH=()=>{
    const appMainBox=document.querySelector('#appMainBox').getBoundingClientRect()
    const topContent=document.querySelector(pageTopEl).getBoundingClientRect()//table 上方的内容
    //18 topContent的间距 32 底部分页的高 18 预留,好多commonSelectForm有间距
    const res=appMainBox.height-topContent.height-paginationH-18
    // console.log('setTableMaxH',appMainBox.height,topContent.height)
    vueObj.tableMaxH=res
  }
  setH()
  window.onresize=function(){
    setH()
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js